<mprd-tv-available-options-skeleton
  *ngIf="!availableOptionsLoaded && !hasError"
></mprd-tv-available-options-skeleton>
<ng-container *ngIf="availableOptionsLoaded || hasError">
  <px-alert
    [alerts]="[
      {
        type: 'error',
        title: 'tv.options.error.title' | translate,
        description: 'tv.options.error.message' | translate,
        isClosable: false,
        taggingErrorType: 'backend'
      }
    ]"
    *ngIf="!availableOptionsLoaded && hasError"
  ></px-alert>
  <ng-container *ngIf="availableOptionsLoaded">
    <mprd-language-toggle (outputLanguage)="setLanguageRestriction($event)"></mprd-language-toggle>

    <div class="panel rs-bg-grey1 clearfix" *ngFor="let category of categories">
      <h3 class="rs-tit6 rs-txt-c1">
        {{ category.name }}
      </h3>

      <div class="rs-flex-row">
        <ng-container *ngFor="let option of selectedProduct.options | filterByOptionCategory: category.id | languageRestriction: languageRestriction | excludeNetflixBuyAndSell: showBuyAndSell">
            <mprd-option
              class="rs-flex-columns small-12 medium-6"
              [product]="selectedProduct"
              [option]="option"
              [activeTvBonus]="activeTvBonus"
              [isUnmigratedTvCustomer]="isUnmigratedTvCustomer"
            ></mprd-option>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <small class="rs-txt-s2 rs-block">{{ 'common.options.priceMention' | translate }}</small>
</ng-container>
